<template>
  <div class="mx-auto w-full flex items-center justify-center pt-10" v-if="loading">
    <Spinner ></Spinner>
  </div>
  <div v-else>
    <connect-embed :type="isAccountOnboarded ? 'account':'onboarding'"></connect-embed>
  </div>
</template>

<script setup>
import { onMounted, useTemplateRef, ref } from 'vue';
import Spinner from './Spinner.vue';
import ConnectEmbed from './ConnectEmbed.vue';

const props = defineProps({
  type: String
});

const spinner = useTemplateRef('loading');
const container = useTemplateRef('container');
const error = useTemplateRef('error');


const loading = ref(true);
const isAccountOnboarded = ref(false);

onMounted(() => {

  let data = {};
  data[csrfTokenName] = csrfTokenValue;
  fetch('/actions/live-yoga-teachers/connect/is-account-onboarded',
      {
        method: "POST",
        headers: {
          'Content-type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(data)
      })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
      })
      .then((response) => {
        console.log(response);
        isAccountOnboarded.value = response.isAccountOnboarded;
        loading.value = false;
      });

});
</script>